import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	externalLinkDeleteDiscardPromptHeader: {
		id: 'servicedesk-external-links.links.delete-discard-prompt.external-link-delete-discard-prompt-header',
		defaultMessage: 'Remove link',
		description: 'Header text for discard prompt on deletion of external link',
	},
	externalLinkDeleteDiscardPromptBody: {
		id: 'servicedesk-external-links.links.delete-discard-prompt.external-link-delete-discard-prompt-body',
		defaultMessage: 'This link will no longer show up on your portal or help center.',
		description: 'Body text for discard prompt on deletion of external link',
	},
	externalLinkDeleteDiscardPromptCancel: {
		id: 'servicedesk-external-links.links.delete-discard-prompt.external-link-delete-discard-prompt-cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button text for discard prompt on deletion of external link',
	},
	externalLinkDeleteDiscardPromptProceed: {
		id: 'servicedesk-external-links.links.delete-discard-prompt.external-link-delete-discard-prompt-proceed',
		defaultMessage: 'Remove link',
		description: 'Proceed button text for discard prompt on deletion of external link',
	},
});
